import { createFileRoute, Link } from "@tanstack/react-router";

import { AccountList } from "../../components/AccountList";
import { CreateAccountForm } from "../../components/CreateAccountForm";

export const Route = createFileRoute("/_auth/bank_accounts")({
  component: RouteComponent,
});

export function RouteComponent() {
  return (
    <main className="page-wrap pb-8">
      <div className="mb-6">
        <h1 className="display-title text-[2rem] mb-1">Bank Accounts</h1>
        <p className="text-[--ink-soft] text-sm m-0">
          Manage your financial accounts and connect external banks.
        </p>
      </div>

      <div className="grid gap-6">
        <section className="island-shell rounded-md p-5">
          <div className="mb-4">
            <p className="island-kicker mb-1.5">New Account</p>
            <h2 className="m-0 text-lg">Create Account</h2>
          </div>
          <CreateAccountForm />
        </section>

        <section className="island-shell rounded-md p-5">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="island-kicker mb-1.5">Your Accounts</p>
              <h2 className="m-0 text-lg">Accounts</h2>
            </div>
            <Link to="/connect">
              <button type="button" className="primary">
                Add Bank
              </button>
            </Link>
          </div>
          <AccountList />
        </section>
      </div>
    </main>
  );
}
